/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AdminTalentPoolUpdateRequestColor } from './adminTalentPoolUpdateRequestColor';
import type { AdminTalentPoolUpdateRequestIcon } from './adminTalentPoolUpdateRequestIcon';

export interface AdminTalentPoolUpdateRequest {
  icon?: AdminTalentPoolUpdateRequestIcon;
  color?: AdminTalentPoolUpdateRequestColor;
  name?: string | null;
  status?: string | null;
  disabled_filter_categories?: string[] | null;
}
